import { useEffect, useState } from "react";
import { AppBar, Drawer, Avatar, IconButton, Tooltip, MenuItem, ImageListItem, List, ListItem, Toolbar, Typography, Box, Button, Stack, Menu } from "@mui/material";
import AdbIcon from '@mui/icons-material/Adb';
import { Theme, useTheme, ThemeProvider } from "@mui/material/styles";

import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from '@mui/icons-material/Settings';
import {

  useNavigate,
  useLocation
} from "react-router-dom";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Link from '@mui/material/Link';


const transitionDuration = 1000;

const themedStyles = (theme, mobileResponsiveWidth) => {
  return {
    appBar: {
      zIndex: theme.zIndex.drawer + 1
    },
    drawer: {
      width: mobileResponsiveWidth,
      "& .MuiBackdrop-root": {
        display: "none"
      }
    },
    menuButton: {
      marginRight: 2
    },
    drawerPaper: {
      width: mobileResponsiveWidth,
      height: mobileResponsiveWidth === '100%' ? '20%' : '100%',
      backgroundColor: "rgba(120, 120, 120, 0.2)"
    },
    content: {
      padding: 4,
      minWidth: mobileResponsiveWidth,
      marginLeft: 0,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: transitionDuration
      })
    },
    contentShift: {
      minWidth: mobileResponsiveWidth,
      marginLeft: mobileResponsiveWidth,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: transitionDuration
      })
    }
  }
}

const Nav = (props) => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [value, setValue] = useState(0);
  const { greaterThan768, greaterthan375, responsiveData } = props.breakPointsData;
  // const [isMobile,setIsMobile]=useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const theme = useTheme();

  const [open, setOpen] = useState(greaterThan768);
  // const pages=[{ text: "Dashboard", route: "/dashboard",name:'dashboard' },{ text: "Merge PDF", route: "/dashboard/mergepdf" ,name:'mergepdf'}, { text: "Image to PDF", route: "/dashboard/imagetopdf",name:'imagetopdf' }, { text: "Compress PDF", route: "/dashboard/compresspdf",name:'compresspdf' }, { text: "Split PDF", route: "/dashboard/splitpdf",name:'splitpdf' }]
  const pages = [];
  const settings = [{ text: "Login", route: "/login", name: 'login' }, { text: "Logout", route: "/logout", name: 'logout' }, { text: "ForgetPAssword", route: "/forgetPAssword", name: 'forgetPAssword' }]



  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleNavigation = (route) => {
    console.log("route-------------", route);
    navigate(route)
    setAnchorElNav(null);
    setAnchorElUser(null);
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const pathMatchRoute = (route) => {
    if (route === location.pathname) {
      return true;
    }
  };

  // useEffect(() => {
  //   setOpen(greaterThan768 || greaterthan375 || !greaterthan375);
  // }, [greaterThan768,greaterthan375]);

  useEffect(() => {
    if (pathMatchRoute('/dashboard/splitpdf') || pathMatchRoute('/dashboard/compresspdf')) {
      setOpen(greaterThan768 || greaterthan375 || !greaterthan375);
    } else {
      setOpen(false)
    }
  }, [location.pathname, greaterThan768, greaterthan375])


  return (
    <div>
      <AppBar position="fixed" sx={themedStyles(theme, responsiveData.responsiveDrawerWidth).appBar}>
        <Toolbar sx={{ justifyContent: 'space-between', width: '100%', backgroundColor: '#606366' }}>

          <Stack direction="row" justifyContent="space-between" alignItems={'center'}>

            <Stack spacing={1} direction='row' justifyContent={'space-between'} alignItems={'center'} sx={{ display: "flex" }}>

              {<ImageListItem sx={{ width: responsiveData.imageWidth, height: responsiveData.imageWidth }}>
                <img
                  src={`/logo.png`}
                  srcSet={`/logo.png`}
                  alt={'Breakfast'}
                  loading="lazy"
                />
              </ImageListItem>
                // <Stack direction='row'>

                //   <Tooltip title="Nav Menu 2" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                //     <IconButton onClick={handleOpenNavMenu} sx={{ p: 0 }}>
                //       <MenuIcon sx={{ fontSize: responsiveData.iconFontSize }} />
                //     </IconButton>
                //   </Tooltip>

                //   <Menu
                //     sx={{ mt: '45px' }}
                //     id="menu-appbar"
                //     anchorEl={anchorElNav}
                //     anchorOrigin={{
                //       vertical: 'top',
                //       horizontal: 'right',
                //     }}
                //     keepMounted
                //     transformOrigin={{
                //       vertical: 'top',
                //       horizontal: 'right',
                //     }}
                //     open={Boolean(anchorElNav)}
                //     onClose={handleCloseNavMenu}
                //   >
                //     {pages.map((page) => (
                //       <MenuItem key={page.text} onClick={() => handleNavigation(page.route)} >
                //         <Typography textAlign="center" >{page.text}</Typography>
                //       </MenuItem>
                //     ))}
                //   </Menu>

                // </Stack>

              }

              <Typography sx={{ fontSize: responsiveData.fontSize }} >
                {greaterthan375 ? 'PASSWORD RESET' : 'PASSWORD RESET'}
              </Typography>
            </Stack>

          </Stack>

          <Stack direction="row" alignItems={'center'}>
            {greaterThan768 && <Box sx={{ flexGrow: 1, display: "flex" }}>
              {pages.map((page) => (
                <ListItem key={page.text} >
                  <Link
                    onClick={() => handleNavigation(page.route)}
                    component="button"
                    sx={{ color: 'white', fontSize: 'calc(8px + 0.3vw)', width: 'calc(16px + 4.5vw)', borderBottom: props.page === page.name ? '2px solid white' : '' }}>
                    {page.text}
                  </Link>
                </ListItem>
              ))}
            </Box>}



          </Stack>
          {/* <Box sx={{ flexGrow: 0 }}>
            <Stack direction="row" justifyContent={'space-between'} alignItems="center" spacing={1}>
              <Tooltip title="Open user Settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Scanner" src="/static/images/avatar/2.jpg" sx={{ width: responsiveData.imageWidth, height: responsiveData.imageWidth }} />
                </IconButton>
              </Tooltip>

              <Menu
                sx={{ mt: '50px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting.text} onClick={() => handleNavigation(setting.route)}>
                    <Typography textAlign="center">{setting.text}</Typography>
                  </MenuItem>
                ))}
              </Menu>

              {greaterthan375 && <Typography noWrap sx={{ fontSize: responsiveData.fontSize }}>
                Scanner
              </Typography>}
            </Stack>
          </Box> */}

        </Toolbar>
      </AppBar>
      {/* <Drawer
        disableEnforceFocus
        variant="temporary"
        anchor={'bottom'}
        open={open}
        sx={themedStyles(theme, responsiveData.responsiveDrawerWidth).drawer}
        PaperProps={{ elevation: 9, sx: themedStyles(theme, responsiveData.responsiveDrawerWidth).drawerPaper }}
      >
        <Toolbar />
        <div>
            <List>
              {
                [{ text: "Contact Form", route: "/form" }, { text: "Card Grid", route: "/grid" }, { text: "Table", route: "/table" }, { text: "Data Grid", route: "/datagrid" }].map((nav, index) => (
                  <ListItem key={nav.text} sx={{borderBottom: '1px solid', borderBottomColor: "primary.main"}}>
                    <Link to={nav.route}>{nav.text}</Link>
                  </ListItem>
                ))
              }
            </List>
          </div>
      </Drawer> */}
    </div>
  )
}

export default Nav